import clsx from "clsx";
import { useState } from "react";
import { createPortal } from "react-dom";

import {
  Accordion,
  AccordionHeader,
  AccordionHeaderName,
  HyphenIcon,
  Loader,
} from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { services } from "@src/dependencies";
import { useApiRequest } from "@utils/http-client";

import { TrekMobileSettingsModal } from "@views/organizations/detail/modals";

import "./trek.section.scss";

export const TrekSection = ({ className, organization }) => {
  const { trekService } = services;
  const { response: data, loading } = useApiRequest(() =>
    trekService.getCareers(organization?.code),
  );

  const [openSettings, setOpenSettings] = useState(false);

  return (
    <div className={clsx("trek-section", loading && "loader", className)}>
      <div className="trek-section-header">
        <h2>
          Careers{" "}
          <span className="badge">{data?.length ?? <HyphenIcon />}</span>
        </h2>
        {organization && (
          <Button
            className="icon"
            onClick={() => setOpenSettings(true)}
            icon="far fa-gear"
          />
        )}
      </div>

      <div className="content-section">
        {data?.map((d) => (
          <Accordion key={`career-${d.id}`}>
            <AccordionHeader>
              <AccordionHeaderName>{d.title}</AccordionHeaderName>
            </AccordionHeader>
          </Accordion>
        ))}
        {loading && <Loader overlay fixed />}
      </div>
      {organization &&
        createPortal(
          <TrekMobileSettingsModal
            open={openSettings}
            onClose={() => setOpenSettings(false)}
            organization={organization}
          />,
          document.body,
        )}
    </div>
  );
};
